import { useEffect, useState } from "react";
import TrackViewBarChart from "./TrackViewBarChart";
import PivotableBarChart from "./PivotableBarChart";

function CostPerGWPChart({ selectedRows, showHeader = false }) {
  const [costPerGWPData, setCostPerGWPData] = useState({
    labels: [],
    datasets: [
      {
        label: "Cost Per GWP ($/kg CO₂e)",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  const [totalCost, setTotalCost] = useState(0.0);
  const [averageCost, setAverageCost] = useState(0.0);
  const predefinedColors = [
    "rgba(34, 139, 34, 0.6)",
    "rgba(60, 179, 113, 0.6)",
    "rgba(50, 205, 50, 0.6)",
    "rgba(0, 128, 0, 0.6)",
    "rgba(144, 238, 144, 0.6)",
    "rgba(46, 139, 87, 0.6)",
    "rgba(154, 205, 50, 0.6)",
    "rgba(85, 107, 47, 0.6)",
    "rgba(34, 177, 76, 0.6)",
    "rgba(60, 179, 113, 0.6)",
  ];
  const predefinedBorderColors = predefinedColors.map((color) => color.replace("0.6", "1"));

  useEffect(() => {
    const labels = selectedRows.map((row) => row.name || row.name || row.organization);
    const gwpData = selectedRows.map((row) => row.gwp);
    const costData = selectedRows.map((row) => parseFloat(row.cost));
    const costPerGWPDataValues = selectedRows.map((row) => {
      const cost = row.cost;
      const gwp = row.gwp;
      return gwp > 0 ? cost / gwp : "N/A";
    });
    const colors = predefinedColors.slice(0, selectedRows.length);
    const borderColors = predefinedBorderColors.slice(0, selectedRows.length);
    let multipliedGwpData = gwpData.map((value, index) => {
      if (selectedRows[index].quantity === undefined) {
        return value;
      }
      return (value * selectedRows[index].quantity).toFixed(2);
    });
    let multipliedCostPerGWPDataValues = costPerGWPDataValues.map((value, index) => {
      const numericValue = parseFloat(value);
      if (selectedRows[index].quantity === undefined) {
        return numericValue;
      }
      return (numericValue * selectedRows[index].quantity).toFixed(2);
    });
    const adjustDatasetCount = (labels, data, backgroundColors, borderColors) => {
      const minBars = 4;
      const currentCount = labels.length;
      if (currentCount < minBars) {
        const missingBars = minBars - currentCount;

        for (let i = 0; i < missingBars; i++) {
          labels.push("");
          data.push(0);
          backgroundColors.push("transparent");
          borderColors.push("transparent");
        }
      }
      return { labels, data, backgroundColors, borderColors };
    };
    const adjustedData = adjustDatasetCount(labels, multipliedGwpData, colors, borderColors);
    setTotalCost(costData.reduce((acc, value) => acc + value, 0));
    setCostPerGWPData({
      labels: adjustedData.labels,
      datasets: [
        {
          label: "Cost Per GWP ($/kg CO₂e)",
          data: multipliedCostPerGWPDataValues,
          backgroundColor: adjustedData.backgroundColors,
          borderColor: adjustedData.borderColors,
          borderWidth: 1,
        },
      ],
    });
  }, [selectedRows]);

  useEffect(() => {
    if (selectedRows.length === 0) {
      setTotalCost(0.0);
      setAverageCost(0.0);
      return;
    }
    setAverageCost(totalCost / selectedRows.length);
  }, [totalCost, selectedRows]);

  return (
    <PivotableBarChart
      title={showHeader ? "Cost Per GWP ($/kg CO₂e)" : undefined}
      usages={selectedRows.map((r) => ({ ...r, cost_per_gwp: r.gwp === 0 ? null : r.cost / r.gwp }))}
      groupBy={"name"}
      countBy={"cost_per_gwp"}
      xAxisLabel="USD / kg CO₂e"
      titleFontWeight={500}
      showTitleDivider={showHeader}
    />
    // <TrackViewBarChart
    //   data={costPerGWPData}
    //   filename={"cost_per_gwp_graph"}
    //   totalValue={totalCost}
    //   averageValue={averageCost}
    //   title={"Cost Per GWP ($/kg CO₂e)"}
    //   unit={"$"}
    //   averageLabel={"Average Cost: "}
    //   totalLabel={"Total Cost: "}
    // />
  );
}

export default CostPerGWPChart;
